/**
 * Supabase Client Singleton for Admin App
 *
 * This file creates a single Supabase client instance for the admin app
 * with app-scoped storage to prevent auth contamination across apps.
 *
 * @module lib/supabase
 */

import { createSupabaseClient } from '@rsvd/supabase-client'

/**
 * Admin app Supabase client singleton
 *
 * - Storage key: 'rsvd-admin-auth'
 * - Auto token refresh enabled
 * - Realtime subscriptions configured
 */
export const supabase = createSupabaseClient('admin')
